module.exports = __webpack_public_path__ + "img/23.6d9e1b39.png";